import React from "react";
import DocumentTypeForm from "../../document_type/form";
import {
  create as createDocumentType,
  update as updateDocumentType
} from "./axios";

const LaboralDocumentTypeForm = props => {

  return(
    <>
      <DocumentTypeForm
        currentCustomer={ props?.currentCustomer || {} }
        documentType={ props?.documentType || {} }
        data={ props?.data || {} }
        configuration={{
          context: 'laboral',
          formName: 'laboral_document_type',
          defaultRequestParams: {}
        }}
        actions={{
          createDocumentType: createDocumentType,
          updateDocumentType: updateDocumentType,
          indexDocumentTypesPath: Routes.laboral_document_types_path,
          showDocumentTypePath: Routes.laboral_document_type_path
        }}
      />
    </>
  )
}

export default LaboralDocumentTypeForm;
